import { InjectionToken } from '@angular/core';
import { SortDir } from './table.util';

/** What a sort header needs from its table (kept separate to avoid an import cycle). */
export interface AdminTableSortHost {
  readonly sortField?: string;
  readonly sortDir: SortDir;
  sortBy(field: string): void;
}

export const ADMIN_TABLE = new InjectionToken<AdminTableSortHost>('ADMIN_TABLE');
